





























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    Button,
    Pagination,
    GenericLoadingSpinner
  }
})
export default class DrivewealthDocuments extends Vue {
  $router: VueRouter;
  $validator: Validator;

  drivewealthStore = useDrivewealthStore();

  @Prop() pageNumber: number;

  @Prop() routeToDrivewealthDocuments: (pageNumber: number) => Location;
  @Prop() routeToDrivewealthDocumentsV2: (
    dwAccountId: number, pageNumber: number,
    partnerId: number, username: string) => Location;
  @Prop({ required: false })
  username: string;
  @Prop({ required: false })
  partnerId: number;

  @Prop() accountId: number;

  get formattedAccountId (): number {
    const propId = this.accountId;

    if (propId) {
      return propId;
    }

    if (this.$route.params && this.$route.params.accountId) {
      return parseInt(this.$route.params.accountId);
    }

    return 0;
  }

  load (): void {
    if (this.accountId) {
      this.drivewealthStore.getDocumentsV2({
        dwAccountId: this.formattedAccountId,
        pageNumber: this.pageNumber,
        username: this.username,
        partnerId: this.partnerId
      });
    }
  }

  @Watch("$props", { deep: true })
  loadTable () {
    this.load();
  }

  created (): void {
    this.load();
  }

  documentFields = [
    {
      key: "posted_date",
      thClass: "text-left"
    },
    {
      key: "document",
      thClass: "text-left"
    }
  ];

  get documentsLoadedV2 (): boolean {
    return this.drivewealthStore.documentsV2Loaded(this.accountId, this.pageNumber);
  }

  get pageTotalV2 (): number {
    return this.drivewealthStore.documentsV2PageTotal(this.accountId, this.pageNumber);
  }

  get documentItems () {
    if (this.accountId) {
      const documentsV2 = this.drivewealthStore.pagedDocumentsById(this.accountId, this.pageNumber);

      if (documentsV2) {
        return documentsV2.map(d => ({
          posted_date: this.formatDate(d.postedDate),
          document: { documentId: d.documentId, description: d.description }
        }));
      }
    }

    return [];
  }

  formatDate (date?: moment.Moment) {
    if (!date) {
      return "";
    }
    return moment(date).format("MMMM D, YYYY");
  }

  onPageChanged (pageNumber: number): void {
    this.$router.push(this.routeToDrivewealthDocumentsV2(this.accountId, pageNumber, this.partnerId, this.username));
  }

  @Watch("pageNumber")
  onRouteValuePageNumberChanged () {
    this.load();
  }

  createDownloadLink (documentId: number): void {
    this.drivewealthStore.loadDocumentInTab({ documentId, username: this.username, partnerId: this.partnerId });
  }
}
